import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, forwardRef, useCallback } from "react";
import { useToggle } from "react-use";
import { cn } from "../../utils";
import { Checkmark, Clipboard, LinkIcon } from "../icons";
import { Button } from "./Button";
export const CopyToClipboard = forwardRef((props, ref) => {
    const { className, iconClassName, text, children, checkmark, ...rest } = props;
    const [check, toggleCheck] = useToggle(false);
    const onClick = useCallback((e) => {
        e.stopPropagation();
        navigator.clipboard
            .writeText(text)
            .then(() => {
            toggleCheck(true);
            setTimeout(toggleCheck, 800);
        })
            .catch(() => { });
    }, [toggleCheck, text]);
    return (_jsx("div", { ref: ref, className: cn("inline-block", className), ...rest, children: check ? ((checkmark ?? _jsx(Checkmark, { className: "text-green-500" }))) : children ? (cloneElement(children, { onClick })) : (_jsx(Clipboard, { onClick: onClick, className: iconClassName })) }));
});
export const CopyToClipboardButton = forwardRef((props, ref) => {
    const { text, children, ...rest } = props;
    return (_jsx(CopyToClipboard, { ref: ref, text: text, checkmark: _jsx(Button, { variant: "outline", size: "icon", children: _jsx(Checkmark, { className: "text-green-500" }) }), ...rest, children: _jsx(Button, { variant: "outline", size: children && typeof children === "string" ? undefined : "icon", children: children ?? _jsx(LinkIcon, {}) }) }));
});
